(function () {
  if (window.GSWishlistPageFixedReady) return;
  window.GSWishlistPageFixedReady = true;

  var WISHLIST_KEY = 'gs_wishlist_items';
  var LEGACY_KEYS = ['wishlist', 'gsWishlist', 'gs_wishlist', 'gse_wishlist', 'theme_wishlist', 'shopify_wishlist'];

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[char];
    });
  }

  function parseStored(value) {
    if (!value) return [];

    try {
      var parsed = JSON.parse(value);

      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
      if (parsed && Array.isArray(parsed.products)) return parsed.products;
    } catch (error) {
      return String(value).split(',').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    }

    return [];
  }

  function normalizeItem(item) {
    if (item === null || item === undefined) return null;

    if (typeof item === 'string' || typeof item === 'number') {
      var value = String(item).trim();

      if (!value) return null;

      return /^\d+$/.test(value)
        ? { id: value, key: value }
        : { handle: value, key: value };
    }

    var handle = String(item.handle || item.product_handle || item.productHandle || '').trim();
    var id = String(item.id || item.product_id || item.productId || '').trim();
    var key = handle || id;

    if (!key) return null;

    return {
      key: key,
      id: id,
      handle: handle,
      title: item.title || item.product_title || item.productTitle || '',
      url: item.url || (handle ? '/products/' + handle : ''),
      image: item.image || item.featured_image || item.featuredImage || '',
      price: item.price || item.price_text || item.priceText || '',
      priceCents: item.priceCents || item.price_cents || item.price_min || item.priceMin || '',
      variantId: item.variantId || item.variant_id || '',
      variantTitle: item.variantTitle || item.variant_title || ''
    };
  }

  function uniqueItems(items) {
    var seen = {};
    var clean = [];

    (items || []).forEach(function (item) {
      var normalized = normalizeItem(item);

      if (!normalized || !normalized.key || seen[normalized.key]) return;

      seen[normalized.key] = true;
      clean.push(normalized);
    });

    return clean;
  }

  function getWishlist() {
    var stored = localStorage.getItem(WISHLIST_KEY);

    if (stored) return uniqueItems(parseStored(stored));

    for (var i = 0; i < LEGACY_KEYS.length; i += 1) {
      var legacy = localStorage.getItem(LEGACY_KEYS[i]);
      if (legacy) return uniqueItems(parseStored(legacy));
    }

    return [];
  }

  function saveWishlist(items) {
    var clean = uniqueItems(items);

    localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));
    updateHeaderCount(clean);

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: {
        items: clean,
        count: clean.length
      }
    }));

    return clean;
  }

  function updateHeaderCount(items) {
    var count = uniqueItems(items || getWishlist()).length;

    qsa('[data-gs-wishlist-count], [data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });

    qsa('[data-gs-wishlist-count-label], [data-wishlist-count-label]').forEach(function (el) {
      el.textContent = count + (count === 1 ? ' item in wishlist' : ' items in wishlist');
    });

    qsa('[data-gs-wishlist-count-bubble], [data-wishlist-count-bubble]').forEach(function (bubble) {
      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', 'hidden');
      }
    });
  }

  function money(cents) {
    cents = Number(cents || 0);
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function sizedImageUrl(url, width) {
    if (!url) return '';

    if (url.indexOf('width=') !== -1) return url;

    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function closeIcon() {
    return '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  }

  function fetchProduct(item) {
    if (!item.handle) return Promise.resolve(item);

    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product) return item;

        var firstVariant = product.variants && product.variants.length ? product.variants[0] : null;

        return normalizeItem({
          id: product.id || item.id,
          handle: product.handle || item.handle,
          title: product.title || item.title,
          url: product.url || item.url || '/products/' + product.handle,
          image: product.featured_image || item.image || (product.images && product.images[0]) || '',
          price: item.price || money(product.price_min || product.price || 0),
          priceCents: product.price_min || product.price || item.priceCents || 0,
          variantId: item.variantId || (firstVariant ? firstVariant.id : ''),
          variantTitle: item.variantTitle || (firstVariant ? firstVariant.title : '')
        });
      })
      .catch(function () {
        return item;
      });
  }

  function hydrate(items) {
    return Promise.all(uniqueItems(items || getWishlist()).map(fetchProduct)).then(function (hydratedItems) {
      var clean = uniqueItems(hydratedItems);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));
      return clean;
    });
  }

  function setState(root, state) {
    root.classList.remove('is-loading', 'is-empty', 'has-items');
    root.classList.add(state);
  }

  function openCartDrawer() {
    var opener = document.querySelector('[data-gs-open-cart]');

    if (opener) {
      opener.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    var drawer = document.querySelector('[data-gs-cart-drawer]');
    if (drawer) {
      drawer.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gs-drawer-open');
    }
  }

  function renderWishlistPage() {
    var root = qs('[data-gs-wishlist-page]');
    if (!root) return;

    var empty = qs('[data-gs-wishlist-empty]', root);
    var grid = qs('[data-gs-wishlist-grid]', root);

    if (!empty || !grid) return;

    setState(root, 'is-loading');

    hydrate(getWishlist()).then(function (items) {
      updateHeaderCount(items);

      if (!items.length) {
        grid.innerHTML = '';
        grid.setAttribute('hidden', 'hidden');
        empty.removeAttribute('hidden');
        setState(root, 'is-empty');
        return;
      }

      empty.setAttribute('hidden', 'hidden');
      grid.removeAttribute('hidden');
      setState(root, 'has-items');

      grid.innerHTML = items.map(function (item) {
        var title = item.title || 'Wishlist product';
        var url = item.url || (item.handle ? '/products/' + item.handle : '#');
        var price = item.price || (item.priceCents ? money(item.priceCents) : '');
        var image = item.image || '';
        var variantId = item.variantId || '';

        return (
          '<li class="freshity-product-card" data-gs-wishlist-item="' + escapeHtml(item.key) + '">' +
            '<article class="freshity-card">' +
              '<div class="freshity-card__media-wrap">' +
                '<a class="freshity-card__media-link" href="' + escapeHtml(url) + '">' +
                  (image ? '<img src="' + escapeHtml(sizedImageUrl(image, 900)) + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '') +
                '</a>' +
                '<button class="freshity-card__remove" type="button" data-gs-wishlist-page-remove="' + escapeHtml(item.key) + '" aria-label="Remove ' + escapeHtml(title) + '">' +
                  closeIcon() +
                '</button>' +
              '</div>' +
              '<div class="freshity-card__info">' +
                '<a class="freshity-card__title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>' +
                (price ? '<p class="freshity-card__price">' + escapeHtml(price) + '</p>' : '') +
                '<div class="freshity-card__actions">' +
                  (variantId ? '<button class="freshity-card__button freshity-card__button--primary" type="button" data-gs-wishlist-page-add-cart="' + escapeHtml(variantId) + '">Add to cart</button>' : '') +
                  '<a class="freshity-card__button freshity-card__button--secondary" href="' + escapeHtml(url) + '">View product</a>' +
                '</div>' +
              '</div>' +
            '</article>' +
          '</li>'
        );
      }).join('');
    });
  }

  function removeItem(key) {
    saveWishlist(getWishlist().filter(function (item) {
      return item.key !== key;
    }));

    renderWishlistPage();

    if (window.GSWishlist && typeof window.GSWishlist.refresh === 'function') {
      window.GSWishlist.refresh();
    }
  }

  function addToCart(variantId, button) {
    if (!variantId) return;

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw json;
          return json;
        });
      })
      .then(function () {
        openCartDrawer();
      })
      .catch(function (error) {
        alert((error && (error.description || error.message)) || 'Unable to add this product to cart.');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-gs-wishlist-page-remove]');

    if (remove) {
      event.preventDefault();
      removeItem(remove.getAttribute('data-gs-wishlist-page-remove'));
      return;
    }

    var addCart = event.target.closest('[data-gs-wishlist-page-add-cart]');

    if (addCart) {
      event.preventDefault();
      addToCart(addCart.getAttribute('data-gs-wishlist-page-add-cart'), addCart);
    }
  });

  document.addEventListener('wishlist:updated', function () {
    renderWishlistPage();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === WISHLIST_KEY || LEGACY_KEYS.indexOf(event.key) !== -1) {
      renderWishlistPage();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    renderWishlistPage();
  });
})();
